import { Outlet, Navigate, useParams, createBrowserRouter } from 'react-router-dom';
import { v1Routes } from './v1.routes';
import { v2Routes } from './v2.routes';
import { v3Routes } from './v3.routes';
import { ErrorPage } from '../pages/ErrorPage';
import ErrorRouterBoundary from './components/ErrorRouterBoundary';

const VERSION = process.env.REACT_APP_VERSION || 'v3';

/**
 * Redirections de rétrocompatibilité pour anciennes URLs versionnées.
 * 
 * Capture les anciennes URLs avec préfixes (/v1/*, /v2/*, /v3/*) et redirige
 * vers les URLs propres (/*) pour maintenir les bookmarks et liens externes.
 * 
 * Exemple : /v3/scan → /scan
 */
function redirectVersionedToClean() {
  return function Redirect() {
    const params = useParams();
    const path = params['*'] || '';
    return <Navigate to={`/${path}`} replace />;
  };
}

const RedirectToClean = redirectVersionedToClean();

function Root() {
  return <Outlet />;
}

// Sélection des routes selon la version active
const versionedRoutes =
  VERSION === 'v1'
    ? v1Routes
    : VERSION === 'v2'
    ? v2Routes
    : v3Routes;  // V3 par défaut

// Redirections de rétrocompatibilité : anciennes URLs → URLs propres
const redirectRoutes =
  VERSION === 'v3'
    ? [
        { path: 'v3/*', element: <RedirectToClean /> },   // /v3/... → /...
        { path: 'v2/*', element: <RedirectToClean /> },   // /v2/... → /...
        { path: 'v1/*', element: <RedirectToClean /> },   // /v1/... → /...
      ]
    : VERSION === 'v2'
    ? [
        { path: 'v2/*', element: <RedirectToClean /> },   // /v2/... → /...
        { path: 'v1/*', element: <RedirectToClean /> },   // /v1/... → /...
      ]
    : VERSION === 'v1'
    ? [
        { path: 'v2/*', element: <RedirectToClean /> },   // /v2/... → /...
      ]
    : [];

const Router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorRouterBoundary />,
    children: [
      ...versionedRoutes,
      ...redirectRoutes,
      { path: '*', element: <ErrorPage /> }
    ]
  }
]);

export default Router;
